import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TranscriptTurnRevisionFailedAction = {
	type: 'TRANSCRIPT_TURN_REVISION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TranscriptTurnRevisionFailedAction => ({
	type: 'TRANSCRIPT_TURN_REVISION_FAILED',
	payload,
});
